import cloneDeep from 'lodash/cloneDeep'
import set from 'lodash/set'
import React, { useState } from 'react'

import StructuredJsonAccordion from './StructuredJsonAccordion'
import StructuredJsonTabs from './StructuredJsonTabs'
import { useJsonData } from './StructuredJson'
import { getDefaultJsonValue, getJsonPath, getJsonValue } from './jsonFieldHelpers'

export default function StructuredJsonBlock(props) {
  const { jsonPath, api, name, label, schema, max, onUpdate } = props
  const { getJsonData } = useJsonData()

  const jsonData = getJsonData()
  const blocks = jsonPath ? getJsonValue(jsonPath, jsonData) : jsonData
  const isTabs = !!jsonPath
  const BlockComponent = isTabs ? StructuredJsonTabs : StructuredJsonAccordion

  const [selected, setSelected] = useState(jsonPath ? name + '0' : '')

  const handleSelection = (id) => {
    if (!isTabs && selected === id) setSelected('')
    else setSelected(id)
  }

  const handleDataChange = (newData) => {
    const currentJsonData = getJsonData()
    if (JSON.stringify(currentJsonData) !== JSON.stringify(newData)) {
      onUpdate && onUpdate(newData)
    }
  }

  const handleAddItem = () => {
    const currentJsonData = getJsonData()
    const newData = cloneDeep(currentJsonData)
    const targetPath = getJsonPath(jsonPath, blocks.length)
    const defaultValue = getDefaultJsonValue(schema)
    set(newData, targetPath, defaultValue)
    handleDataChange(newData)
  }

  const handleDeleteItem = (index) => {
    const currentJsonData = getJsonData()
    const newData = cloneDeep(currentJsonData)
    if (jsonPath) {
      const newValue = getJsonValue(jsonPath, newData)
      newValue.splice(index, 1)
      set(newData, jsonPath, newValue)
    } else {
      newData.splice(index, 1)
    }
    handleDataChange(newData)
  }

  return (
    <BlockComponent
      selected={selected}
      api={api}
      name={name}
      label={label}
      blocks={blocks}
      max={max}
      schema={schema}
      jsonPath={jsonPath}
      onAddItem={handleAddItem}
      onDeleteItem={handleDeleteItem}
      onSelect={handleSelection}
      onUpdate={onUpdate}
    />
  )
}
